'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var numericalRegex = /\d/;
var removeKeys = new Set(['Backspace', 'Delete']);
var useKeyDown = function (_a) {
    var value = _a.value, onCodeEntered = _a.onCodeEntered, onCodeRemoved = _a.onCodeRemoved;
    var callback = React.useCallback(function (event) {
        var key = event.key;
        var isCodeEnteredOnAlreadyFilledInput = numericalRegex.test(key) && value.toString().length === 1;
        var isKeyPressedOnEmptyInput = removeKeys.has(key) && value.toString().length === 0;
        if (isCodeEnteredOnAlreadyFilledInput) {
            onCodeEntered(key);
        }
        if (isKeyPressedOnEmptyInput) {
            onCodeRemoved();
        }
    }, [value, onCodeEntered, onCodeRemoved]);
    return callback;
};
var useChange = function (_a) {
    var value = _a.value, onCodeEntered = _a.onCodeEntered, onCodeRemoved = _a.onCodeRemoved;
    var callback = React.useCallback(function (event) {
        var val = event.currentTarget.value.toString();
        var isCodeEntered = val.length > 0 && value.toString().length === 0 && numericalRegex.test(val);
        var isCodeRemoved = val.length === 0 && value.toString().length > 0;
        if (isCodeEntered) {
            onCodeEntered(val);
        }
        if (isCodeRemoved) {
            onCodeRemoved();
        }
    }, [value, onCodeEntered, onCodeRemoved]);
    return callback;
};
var useDirection = function () {
    var _a = tslib_es6.__read(React.useState('forward'), 2), direction = _a[0], setDirection = _a[1];
    var setForward = function () { return setDirection('forward'); };
    var setBackward = function () { return setDirection('backward'); };
    return [direction, setForward, setBackward];
};
var usePincode = function (_a) {
    var length = _a.length, setForward = _a.setForward, setBackward = _a.setBackward;
    var _b = tslib_es6.__read(React.useState([]), 2), pincodes = _b[0], setPincodes = _b[1];
    var onCodeArrival = React.useCallback(function (code) {
        if (pincodes.length < length) {
            setPincodes(tslib_es6.__spread(pincodes, [parseInt(code, 10)]));
            setForward();
        }
    }, [pincodes]);
    var onCodeWithdrawal = React.useCallback(function () {
        if (pincodes.length > 0) {
            setPincodes(pincodes.slice(0, pincodes.length - 1));
            setBackward();
        }
    }, [pincodes]);
    return [pincodes, onCodeArrival, onCodeWithdrawal];
};

var Input = styled__default.input(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  border: none;\n  border-bottom: 1px solid #000;\n  padding: 9px 0;\n  color: ", ";\n  font: 400 52px/36px ", ";\n  width: 32px;\n  outline: none;\n  &:not(:last-child) {\n    margin-right: 23px;\n  }\n"], ["\n  border: none;\n  border-bottom: 1px solid #000;\n  padding: 9px 0;\n  color: ", ";\n  font: 400 52px/36px ", ";\n  width: 32px;\n  outline: none;\n  &:not(:last-child) {\n    margin-right: 23px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.darkGrey6;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var useFocus = function () {
    var htmlElementRef = React.useRef();
    var setFocus = function () {
        var currentElement = htmlElementRef.current;
        if (currentElement) {
            currentElement.focus();
        }
    };
    return [htmlElementRef, setFocus];
};
var PinInput = function (_a) {
    var index = _a.index, value = _a.value, onCodeEntered = _a.onCodeEntered, placeholder = _a.placeholder, isFocused = _a.isFocused, onCodeRemoved = _a.onCodeRemoved;
    var _b = tslib_es6.__read(useFocus(), 2), inputRef = _b[0], enableFocus = _b[1];
    var onKeyDown = useKeyDown({ value: value, onCodeEntered: onCodeEntered, onCodeRemoved: onCodeRemoved });
    var onChange = useChange({ value: value, onCodeEntered: onCodeEntered, onCodeRemoved: onCodeRemoved });
    React.useEffect(function () {
        if (isFocused) {
            enableFocus();
        }
    }, [isFocused]);
    return (React__default.createElement(Input, { "aria-label": "Pincode numeric input " + index, maxLength: 1, value: value, placeholder: placeholder, ref: inputRef, onChange: onChange, pattern: "[0-9]", onKeyDown: onKeyDown }));
};
var templateObject_1;

exports.PinInput = PinInput;
exports.useDirection = useDirection;
exports.usePincode = usePincode;
